var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_572947",
    "data-name": 572947,
    x: 6,
    width: 48,
    height: 60,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAA8CAYAAAAgwDn8AAADrUlEQVRogdWaWahOURTHf/eaLiKZuhGZZR7KkGQIL8jsTVKXpMQjyoOhKBkevHhAEiVCiqJkVhSuTOHmXmPGqwxxDVnatU59zj3fOXuf6zvnfP/6Xr69z97//1ln77X2WrtEREgZ3YEJwGjgK7Aa+GVNyQhI6ddHRA5KfSxw4dM4pZe/CViTp62fy0BJC+gNHAKGh/QpdRkwSQHmW78JtIro99ZlUCe1DUAL4LoFeYM7WRRwAuhg0e8ncNVl4CQELAUmW/bdCfxwGbzQfqAp8A1oZNm/K/DCZYJCW2CgA/nzruRJQMBYy37GSvPjTFBoATbf/kdgCFAbZ4JC+4EeEe3vgRHAs7gTFNoCbUPaHgMjG0KeBAQEbYkPgA0a8zxt6ASF3kYHAYvMPEANcAG4+z8ncBUwXncWE5S11Df8St1/pb5dW5QBk/QcYNZKRxX6BngEXAIuRo5lGXevFZEnAbG7Hw9EZL2IDA4Za46I7BeRNxbj3RCRxWHcoiwwBVgHjHExk+I2cBK4r2ttADAX6BtjrDvK43i9lhB1qy3eUNLY5ueZj/yyDJL3cCzqE2oNfIph5iRxSj/HH0F+IHrlp49pwHICHNlGYGgRCDC4h88PtAM+pErJDib4mwVcxhfMbc4waQ/V6kxfen94FugFVKXNLgImFOkP1OV289bAwqyxDUCFnzw5AvqkzS4CZ/TIWQ+egN5ZZJ2DlfkajID2eqTLKq5odJpXQBeHzEEauBQ2Z6mGDllGaKrFCGiWcQElYY2lQVtTxtA5SsDnjAsYFtZoPHE58Do5Ps6o0/P3n6AHS/UQneUwokxLUoHwHFnefTYjWAX0DBNQDGH0vqA/PQHVyXKJBZOP2uJ/0Aun+2v6oxhwWbN91fhOZA9j5mzSgMkIzjRRau6Z+HCRkEejh9OmWJ5rge5Fshb+Qa4FarQcWkzY409sjQKuFZGAcn9e6HoRODUPR8y1hKDM3Ip0+DhjOyEFDlO06JRh8sYXjCOkRrYjWT7OWOI9EFbgqI2oMqaFvZojihQw1ss/Zgg1msP67VEKK7OadMaujAmYmkseyyrlc029pI3dud++iwBzJr2VMvkqTb599zfYVOor494k+U+4kI88joXuicAxoI0DL+NPzgHvgG56wbWdw/NHgXmhPRwvvZaLyImIKuI3vdBqCtpNfM+3FpEKETlrUY3casMp7l2J6cAMvbDRXFMfZrGbbddYyebqpDk8zVarGH9jqkVfdIwDesAKB/AXOoMFuAUOgIkAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.8a6b6aa732979e05c0d40cc903b408e9.svg";
export { ForwardRef as ReactComponent };